<template>
    <div class="header-container">
      <nav class="navbar navbar-default navbar-fixed-top" role="navigation">
        <div class="container-fluid"> 
          <div class="navbar-header">
            <button type="button" class="navbar-toggle" data-toggle="collapse"
                data-target="#example-navbar-collapse" @click="swithBtn">
              <span class="sr-only">切换导航</span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
            </button>
            <router-link to="/"><img class="navbar-brand logo" src="../../assets/images/MPT Solution_logo_blue.svg" @click="hideNav"></router-link>
          </div>
          <div class="collapse navbar-collapse" id="example-navbar-collapse">
            <ul class="nav navbar-nav" >
              <li v-for="(item,index) in routes()" :key="index" class="dropdown nav-item" v-if="!item.hideMenu">
                <a data-toggle="dropdown" class="parentMenu" v-if="$i18n.locale=='EN'">{{item.name}}</a>
                <a data-toggle="dropdown" class="parentMenu" v-if="$i18n.locale=='CN'">{{item.namecn}}</a>
                <a data-toggle="dropdown" class="parentMenu" v-if="$i18n.locale=='CHT'">{{item.namecht}}</a>
                <a data-toggle="dropdown" class="parentMenu" v-if="$i18n.locale=='JP'">{{item.namejp}}</a>
                <hr class="nav-item-active"/>
                <ul class="dropdown-menu">
                  <li v-for="(subItem,index) in item.children" :key="index" @click="hideNav">
                    <router-link :to="subItem.path" v-if="$i18n.locale=='EN'">{{subItem.name}}</router-link>
                    <router-link :to="subItem.path" v-if="$i18n.locale=='CN'">{{subItem.namecn}}</router-link>
                    <router-link :to="subItem.path" v-if="$i18n.locale=='CHT'">{{subItem.namecht}}</router-link>
                    <router-link :to="subItem.path" v-if="$i18n.locale=='JP'">{{subItem.namejp}}</router-link>
                  </li>
                </ul>
              </li>
              <li class="dropdown nav-item langHide">
                <a data-toggle="dropdown" class="parentMenu">{{currentLang}}</a>
                <hr class="nav-item-active"/>
                <ul class="dropdown-menu lang-dropdown">
                  <li v-for="(item,index) in $t('common.lang')" :key="index" @click="changeLang(item.value)">
                    <a v-if="currentLang=='EN' && item.name=='CHT'">繁中</a>
                    <a v-else-if="currentLang=='EN' && item.name=='CN'">简中</a>
                    <a v-else-if="currentLang=='EN' && item.name=='JP'">日語</a>
                    <a v-else>{{item.name}}</a>
                  </li>
                </ul>
              </li>
              <li @click="hideNav" class="dropdown nav-item nav-btn in-btn">
                <a href="https://www.linkedin.com/company/mpt-solution" class="btn btn-inline" target="_blank">
                  Linked <span class="btn-inline-span1">i</span><span class="btn-inline-span2">n</span>
                </a>
              </li>
              <li @click="hideNav" class="dropdown nav-item nav-btn">
                <router-link class="btn btn-inline" to="/ContactUs">{{$t('common.connect')}}</router-link>
              </li>
              <li class="dropdown nav-item langShow">
                <a data-toggle="dropdown" class="parentMenu">{{currentLang}}</a>
                <hr class="nav-item-active"/>
                <ul class="dropdown-menu lang-dropdown">
                  <li v-for="(item,index) in $t('common.lang')" :key="index" @click="changeLang(item.value)">
                    <a v-if="currentLang=='EN' && item.name=='CHT'">繁中</a>
                    <a v-else-if="currentLang=='EN' && item.name=='CN'">简中</a>
                    <a v-else-if="currentLang=='EN' && item.name=='JP'">日語</a>
                    <a v-else>{{item.name}}</a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      
    </div>
</template>
<script>
  export default {
    data() {
      return {
        currentLang:"EN",
      };
    },
    mounted(){
      if(localStorage.getItem('lang')){
        if(localStorage.getItem('lang')=='EN'){
          this.currentLang = "EN"
        }else if(localStorage.getItem('lang')=='CHT'){
          this.currentLang = "繁中"
        }else if(localStorage.getItem('lang')=='CN'){
          this.currentLang = "简中"
        }else if(localStorage.getItem('lang')=='JP'){
          this.currentLang = "日本語"
        }
      }else{
        localStorage.setItem('lang','EN')
      }
      $(document).ready(function(){
          $(document).off('click.bs.dropdown.data-api'); // 关闭点击切换导航菜单事件
          dropdownOpen();//调用鼠标滑过切换导航事件
      });
      function dropdownOpen() {
          var $dropdownLi = $('li.dropdown');
          $dropdownLi.mouseover(function() {
              $(this).addClass('open');
          }).mouseout(function() {
              $(this).removeClass('open');
          });
      }
    },
    methods: {
      changeLang(val){
        this.$i18n.locale = val
        localStorage.setItem('lang',val)
        if(val=='EN'){
          this.currentLang = "EN"
        }else if(val=='CHT'){
          this.currentLang = "繁中"
        }else if(val=='CN'){
          this.currentLang = "简中"
        }else if(val=='JP'){
          this.currentLang = "日本語"
        }
        $("#example-navbar-collapse").collapse('hide');
        this.$router.go(0)
      },
      routes() {
        return this.$router.options.routes
        console.log(this.$router.options.routes,"2222")
      },
      swithBtn(){
        if(!$(".navbar-collapse").hasClass("in")){
          setTimeout(() => {
            $(".navbar-fixed-top .navbar-collapse").animate({
              "max-height":$(window).height()-69,
              "height":$(window).height()-69
            })
          }, 353);
        }
      },
      // 点击链接隐藏导航栏
      hideNav:function(){
        $("#example-navbar-collapse").collapse('hide');
      }
    },
  }
</script>
<style scoped>
  .container-fluid{
    padding:0 10rem;
    background: #fff;
  }
  .navbar{
    margin-bottom: 0;
    height: 8rem;
    box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.16);
  }
  .navbar-default{
    background:#fff;
    border:none;
  }
  .navbar-default .navbar-nav>.active>a, .navbar-default .navbar-nav>.active>a:focus, .navbar-default .navbar-nav>.active>a:hover{
    color:#0b1c36;
    background:none;
  }
  .navbar-nav a.router-link-exact-active,.navbar-nav a.router-link-exact-active:hover{
    background:none !important;
  }
  .navbar-nav a:hover{
    cursor: pointer;
  }
  .navbar-default .navbar-collapse{
    background: #fff;
    border: none;
  }
  .navbar-toggle{
    margin:0;
    padding:1rem 0;
  }
  .navbar-default .navbar-toggle{
    border:none;
  }
  .navbar-default .navbar-toggle:hover{
    background:none;
  }
  .navbar-default .navbar-toggle .icon-bar{
    background-color:#00457A;
  }
  .navbar-toggle .icon-bar{
    width:2.2rem;
    height: .15rem;
  }
  .navbar-toggle .icon-bar+.icon-bar{
    margin-top:0.5rem;
  }
  
  .collapse{
    float:right;
  }
  .logo{
    height: 8rem;
    border:0;
  }
  .navbar-nav>li>a{
    font-size: 1.6rem;
    font-weight: 600;
    color:#0B1C36;
    line-height: 5rem;
  }
  .navbar-nav>.nav-btn>a{
    padding: 0;
    color:#fff;
    margin-top: 1.5rem;
    margin-left: 15px;
    margin-right: 15px;
  }
  .navbar-default .navbar-nav>.nav-btn>.btn:hover,.navbar-default .navbar-nav>.nav-btn>.btn:focus{
    background:#D74B00 !important; 
    color:#fff !important;
  }
  .navbar-nav .nav-btn a.router-link-exact-active, .navbar-nav .nav-btn a.router-link-exact-active:hover{
    background: #29aae1 !important;
    color:#fff !important;
  }
  .dropdown-menu{
    border:none;
    border-radius: 0;
  }
  .lang-dropdown{
    min-width: auto !important;
    padding:0 5px;
  }
  .navbar .nav > li .dropdown-menu li>a{
    font-size: 1.6rem;
    text-align: left;
    padding:1rem
  }
  .navbar-default .navbar-nav>.open>a, .navbar-default .navbar-nav>.open>a:focus, .navbar-default .navbar-nav>.open>a:hover{
    color:initial;
    background:none;
  }
  .nav-item-active{
    display: none;
  }
  .langHide{
    display: none;
  }
  .langShow{
    display: block;
  }
  .navbar>.container-fluid .navbar-brand{
    margin:0;
  }
  .navbar-brand{
    padding:2rem 0;
  }
  @media (min-width: 768px){
    .nav-item{
      position: relative;
    }
    .nav-item-active{
      position: absolute;
      bottom: .3rem;
      left: 0;
      background:#29aae1;
      width:100%;
      height:4px;
      border-radius: 4px;
      margin:0;
      padding:0;
      border:none;
    }
    .nav-item:hover .nav-item-active{
      display: block;
    }
    .btn-inline{
      max-width: 16rem;
    }
    .btn-inline-span1{
      color:#FFF;
      font-size:2rem
    }
    .btn-inline-span2{
      color:#FFF;
      font-size:1.8rem
    }
  }
  @media (min-width:768px) and (max-width:1024px){
    .navbar-default .navbar-toggle{
      height: 8rem;
    }
    .container-fluid{
      padding:0 2rem;
    }
    .navbar-nav{
      margin-left: 1rem;
    }
    .navbar-nav>li>a{
      font-size: 1.4rem;
      padding:0 1rem;
      line-height: 8rem;
    }
    .navbar-nav>.nav-btn>a{
      margin-top: 0;
    }
    .navbar-nav>.nav-btn{
      margin-top: 2rem;
    }
    .navbar-nav>.nav-btn>a{
      line-height: 4rem;
      color: #fff;
    }
    .btn-inline{
      width: 12rem;
      height:4rem;
      line-height: 4rem;
      font-size: 1.4rem;
      margin-left: 2rem;
      margin-bottom: 1rem;
    }
    .navbar-brand{
      width:auto;
      height: 8rem;
    }
    .navbar>.container-fluid .navbar-brand{
      margin-left: 0;
      padding-left: 0;
    }
    .btn-inline-span1{
      color:#FFF;
      font-size:2rem
    }
    .btn-inline-span2{
      color:#FFF;
      font-size:1.8rem
    }
  }
  @media (max-width:767px){
    .container-fluid{
      padding:0 1rem;
      background: #fff;
      overflow: hidden;
    }
    .container-fluid .navbar-header{
      margin:0;
    }
    .btn-get{
      margin:0;
      margin-bottom: 1.2rem;
      width:12rem;
    }
    .navbar{
      height: 3.4rem;
    }
    .navbar-brand{
      margin-top:0;
      padding:0.5rem 0;
      display: block;
      height: 3.4rem;
    }
    .navbar-default .navbar-collapse{
      width: 100%;
      margin:0 auto;
    }
    .navbar-nav>li>a{
      font-size:0.8rem;
    }
    .navbar .nav > li .dropdown-menu li>a{
      text-align: center;
      font-size: 0.8rem;
    }
    .navbar-nav>li>a{
      line-height: 2rem;
    }
    .navbar-nav>.nav-btn>a{
      line-height: 3rem;
      margin: 0 auto;
    }
    .btn-inline{
      float:initial;
      margin:1rem auto;
    }
    .in-btn{
      margin-bottom: 1rem;
    }
    .btn-inline-span1{
      color:#FFF;
      font-size:2rem
    }
    .btn-inline-span2{
      color:#FFF;
      font-size:1.8rem
    }
  }
  @media (max-width:767px) {
    .navbar-default .navbar-collapse{
      width: 100%;
      margin:0 auto;
    }
    .btn-inline{
      float:initial;
      margin:1rem auto;
      margin-bottom: 2rem;
    }
    .navbar .nav > li .dropdown-menu li>a{
      text-align: center;
      font-size: 0.8rem;
    }
    .navbar-nav{
      margin-left: 0;
    }
    .langHide{
      display: block;
    }
    .langShow{
      display: none;
    }
    .in-btn{
      margin-bottom: 1rem;
    }
    .btn-inline-span1{
      color:#FFF;
      font-size:1.2rem
    }
    .btn-inline-span2{
      color:#FFF;
      font-size:1rem
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/Navi/Navi.vue